import BoardCard from '@/shared-components/forms/add-board-content/shared-components/BoardCard';
import InfiniteScroll from '@/shared-components/lists/components/InfiniteScroll';

import './styles/BoardVirtualList.css';

function BoardVirtualList(
  {
    items,
    onLoadMore,
    renderItem,
    cardVariant = 'default',
    gridVariant = '',
    shouldLoadMore: shouldLoadMoreOverride,
    listLength: listLengthOverride
  }
) {
  const computedShouldLoadMore =
    typeof shouldLoadMoreOverride === 'boolean'
      ? shouldLoadMoreOverride
      : items.data.length < items.totalDocs;

  const computedListLength =
    typeof listLengthOverride === 'number'
      ? listLengthOverride
      : items.data.length;

  return (
    <InfiniteScroll
      className="profile-board__infinite-scroll-container"
      onLoadMore={onLoadMore}
      shouldLoadMore={computedShouldLoadMore}
      offsetElements={3}
      listLength={computedListLength}
    >  
      {({ infiniteScrollAssigner }) => (
        <div
          className={`board-grid ${gridVariant ? `board-grid--${gridVariant}` : ''}`}
        >
          {items.data.map((item, idx) => (
            <div
              key={item._id}
              data-item-id={item._id}
              className="board-grid__item"
              ref={infiniteScrollAssigner(idx)}
            >
              {/* allow ArticlesVirtualList to inject a custom renderer if it wants */}
              {renderItem?.(item) ?? <BoardCard data={item} variant={cardVariant} />}
            </div>
          ))}
        </div>
      )}
    </InfiniteScroll>

  );
}
export default BoardVirtualList;
